import DatePickerWrapper from "@Components/DatePicker/DatePickerWrapper";
import Input from "@Components/Input";
import {
  getMaxDateObject,
  getMinDateObject,
  getObjectFromDate,
  monthsArray,
} from "@Components/DatePicker/helper";
import { useEffect, useState } from "react";
import useIsDesktop from "hooks/useIsDesktop";
import styles from "../../../LeadFormModal/LeadFormModal.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

const MoveInDropdown = ({
  error,
  setErrors,
  moveIn,
  setMoveIn,
  datePickerStyles = "",
  testIdPrefix = "",
}: any) => {
  const [displayMoveIn, setDisplayMoveIn] = useState<string>("");
  const { month, day, year } = getObjectFromDate(new Date());
  const { year: maxYear } = getMaxDateObject(1, 0, -1);
  const { year: minYear } = getMinDateObject(1, 0, 1);
  const isDesktop = useIsDesktop();
  const [isMoveInCalendarOpened, setIsMoveInCalendarOpened] = useState(false);

  const getMoveInDisplayValue = () => {
    if (!moveIn) return "";
    const date = moveIn.split("/");
    const day2 = date[0];
    const shortMonth = monthsArray[date[1] - 1];
    const year2 = date[2];
    return `${shortMonth} ${day2}, ${year2}`;
  };

  const { t } = useTranslationHook();

  const toggleOpenMoveInCalendar = (val: boolean) => {
    setIsMoveInCalendarOpened(val);
  };

  const handleSelectDate = (date: Record<any, string | number>) => {
    const { dayState, monthState, yearState } = date;
    const moveInDate = `${dayState}/${monthState}/${yearState}`;
    setMoveIn(moveInDate);
    if (!isDesktop) {
      toggleOpenMoveInCalendar(false);
    }
    setErrors((errors: any) => ({ ...errors, moveIn: "" }));
  };

  useEffect(() => {
    setDisplayMoveIn(getMoveInDisplayValue());
  }, [moveIn]);

  return (
    <div className={styles.moveInSection}>
      <Input
        dataTestId="generic-leadform-input-moveInDate"
        type="text"
        label={t("leadform.components.personaldetailsform.moveinlabel")}
        placeholder={t("leadform.components.personaldetailsform.moveinplaceholder")}
        value={displayMoveIn}
        onFocus={() => toggleOpenMoveInCalendar(true)}
        showErrorMessage={Boolean(error)}
        clearable
        handleClear={() => setMoveIn("")}
        error={error}
        data-testid={`${testIdPrefix}leadform-input-moveInDate`}
        required
        readOnly
        id="moveInAccomodation"
      />
      {isMoveInCalendarOpened && (
        <DatePickerWrapper
          maxYear={maxYear}
          minYear={minYear}
          day={day}
          month={month}
          year={year}
          handleSelectDate={handleSelectDate}
          openInBottom
          datePickerStyles={datePickerStyles}
          hideDatePicker={() => toggleOpenMoveInCalendar(false)}
          testIdPrefix={testIdPrefix}
        />
      )}
    </div>
  );
};

export default wrapperHOC(MoveInDropdown, {
  componentName: "MoveInDropdown-dropdown-LeadForm-Global",
  showForChina: true,
});
